require('./polyfill');

var tool = require('./tool');
var dataService = require('./dataService');
var defaultUploadAws = require('./uploadAws');
var multipartUploadAws = require('./aws/multipartUploadAws');
var uploadCos = require('./cos/index');
var multipartUploadCos = require('./cos/multipartUploadCos');
var logger = require('./logger');

var AwsPartialUploader = require('./partial/uploadAwsPartial');
var CosPartialUploader = require('./partial/uploadCosPartial');

function getType(bucketInfoAndCredentialInfo) {
    if (
        !bucketInfoAndCredentialInfo ||
        !bucketInfoAndCredentialInfo.bucket_info ||
        !bucketInfoAndCredentialInfo.bucket_info.os_type
    ) {
        return false;
    }
    return bucketInfoAndCredentialInfo.bucket_info.os_type.toLocaleLowerCase();
}

function isAws(bucketInfoAndCredentialInfo) {
    return getType(bucketInfoAndCredentialInfo) === 'aws';
}

/**
 * 这个是cos兜底方案，如果umuos返回bos，需要按照bos的处理
 * @param {*} file
 * @param {*} uploadOptions
 */
function handleCos(file, uploadOptions) {
    uploadCos.getBucketInfoAndCredentialInfo(file, uploadOptions).then(
        function (result) {
            if (!result || result.error_code != 0 || !result.data) {
                logger.error('[umu-upload cos] handleCos getBucketInfoAndCredentialInfo result is null:', result);
                uploadOptions.error && uploadOptions.error();
                return;
            }
            var bucketInfoAndCredentialInfo = result.data || {};
            if (isAws(bucketInfoAndCredentialInfo)) {
                uploadAws(file, uploadOptions);
            } else {
                if (uploadOptions.supportsResumeUpload && file.size > 10 * 1024 * 1024) {
                    return multipartUploadCos.upload(file, uploadOptions, bucketInfoAndCredentialInfo);
                } else {
                    return uploadCos.upload(file, uploadOptions, bucketInfoAndCredentialInfo);
                }
            }
        },
        function (err, data) {
            logger.error('[umu-upload cos] handleCos error:', err, file && file.name, data);
            uploadOptions.error && uploadOptions.error();
        }
    );
}

/**
 * 兼容处理
 * @param {*} providerName 供应商名称，bos，cos，aws
 */
function uploadByProvider(file, uploadOptions, providerName) {
    switch (providerName) {
        case 'cos':
            return handleCos(file, uploadOptions);
        case 'aws':
            return uploadAws(file, uploadOptions);
        default:
            break;
    }
}

function handleCosPartialUpload(file, uploadOptions) {
    return uploadCos.getBucketInfoAndCredentialInfo(file, uploadOptions).then(
        function (result) {
            if (!result || result.error_code != 0 || !result.data) {
                logger.error('[umu-upload cos] handleCosPartialUpload result is null:', result);
                uploadOptions.error && uploadOptions.error();
                // 明确 reject，让调用方能捕获失败
                return Promise.reject(new Error('handleCosPartialUpload: invalid credential response'));
            }
            var bucketInfoAndCredentialInfo = result.data || {};
            if (isAws(bucketInfoAndCredentialInfo)) {
                return AwsPartialUploader;
            } else {
                return CosPartialUploader;
            }
        },
        function (err) {
            logger.error('[umu-upload cos] handleCosPartialUpload error:', err);
            uploadOptions.error && uploadOptions.error();
            return Promise.reject(err || new Error('handleCosPartialUpload: network error'));
        }
    );
}

/**
 * 兼容处理
 * @param {*} providerName 供应商名称，bos，cos，aws
 */
var CREDENTIAL_RETRY_MAX = 3;
var CREDENTIAL_RETRY_DELAY_MS = 3000;

function partialUploadByProvider(file, uploadOptions, callback, providerName) {
    switch (providerName) {
        case 'cos':
            return new Promise(function (resolve, reject) {
                var retryCount = 0;

                function onFatalError(err) {
                    logger.error('[umu-upload] partialUploadByProvider: all credential retries exhausted');
                    if (typeof callback === 'function') {
                        callback(err, null);
                    }
                    reject(err);
                }

                function tryCreateUploader() {
                    handleCosPartialUpload(file, uploadOptions).then(function (UploaderClass) {
                        resolve(new UploaderClass(file, uploadOptions, callback));
                    }).catch(function (err) {
                        // handleCosPartialUpload reject（接口 500、网络错误、返回值无效等）
                        if (retryCount < CREDENTIAL_RETRY_MAX) {
                            retryCount++;
                            logger.warn('[umu-upload] partialUploadByProvider: credential request failed, retrying (' + retryCount + '/' + CREDENTIAL_RETRY_MAX + ')');
                            setTimeout(tryCreateUploader, CREDENTIAL_RETRY_DELAY_MS);
                        } else {
                            onFatalError(err || new Error('Failed to initialize upload: credential request failed after retries'));
                        }
                    });
                }

                tryCreateUploader();
            });
        case 'aws':
            return Promise.resolve(new AwsPartialUploader(file, uploadOptions, callback));
        default:
            console.error('[umu-upload] partialUploadByProvider Partial uploader not support provider ' + providerName);
            break;
    }
}

function cancelUpload(uploadId, providerName, isMultipart = false) {
    if (!providerName) {
        return false;
    }
    switch (providerName) {
        case 'cos':
            return uploadCos.cancelUpload(uploadId);
        case 'aws':
            if (isMultipart) {
                return multipartUploadAws.cancelUpload(uploadId);
            } else {
                return defaultUploadAws.cancelUpload(uploadId);
            }
        default:
            return false;
    }
}

function getUploadTasks(providerName, includeMultipart = false) {
    if (!providerName) {
        return [];
    }
    switch (providerName) {
        case 'cos':
            return uploadCos.getUploadTasks();
        case 'aws':
            var tasks = defaultUploadAws.getUploadTasks();
            if (includeMultipart) {
                var multipartTasks = multipartUploadAws.getUploadTasks();
                tasks = tasks.concat(multipartTasks);
            }
            return tasks;
        default:
            return [];
    }
}

function uploadAws(file, uploadOptions) {
    // 文件大于 10 mb 启用断点续传
    if (uploadOptions.supportsResumeUpload && file.size > 10 * 1024 * 1024) {
        return multipartUploadAws(file, uploadOptions);
    } else {
        return defaultUploadAws(file, uploadOptions);
    }
}


module.exports = {
    isInWhiteList: dataService.isInWhiteList,
    expandAccept: tool.expandAccept,
    uploadAws: uploadAws,
    uploadCos: uploadCos.upload,
    uploadByProvider: uploadByProvider,
    AwsPartialUploader: AwsPartialUploader,
    CosPartialUploader: CosPartialUploader,
    partialUploadByProvider: partialUploadByProvider,
    cancelUpload: cancelUpload,
    getUploadTasks: getUploadTasks,
};
